export const RibbonTypes = {
  WHITE_RIBBON_BLACK_TEXT: 'WHITE_RIBBON_BLACK_TEXT',
  BLACK_RIBBON_WHITE_TEXT: 'BLACK_RIBBON_WHITE_TEXT',
  NO_RIBBON_WHITE_TEXT: 'NO_RIBBON_WHITE_TEXT',
  NO_RIBBON_BLACK_TEXT: 'NO_RIBBON_BLACK_TEXT',
};

export const EXPERIENCE_TYPE_LABELS = {
  AUTOGRAPH: 'AUTOGRAPHS',
  PHOTO_OP: 'PHOTO OPS',
};

export const EXPERIENCE_HEADING_LABELS = {
  AUTOGRAPH: 'Autographs',
  PHOTO_OP: 'Photo Ops',
  LEARN_MORE: 'Special experiences',
};

export const NO_RIBBON_EXPERIENCE_TYPES = new Set(['AUTOGRAPH', 'PHOTO_OP']);

export const NO_RIBBON_TYPES = new Set([
  RibbonTypes.NO_RIBBON_WHITE_TEXT,
  RibbonTypes.NO_RIBBON_BLACK_TEXT,
]);

export const imagesMap = {
  WHITE_RIBBON_BLACK_TEXT: {
    AUTOGRAPH:
      '/uploads/FXHQ25_Photo_Autograph_Festival_Pro_Graphics_AUTOGRAPHS_BLACK_632_X_386.png',
    PHOTO_OP:
      '/uploads/FXHQ25_Photo_Op_Festival_Pro_Graphics_PO_BLACK_632_X_386.png',
  },
  BLACK_RIBBON_WHITE_TEXT: {
    AUTOGRAPH:
      '/uploads/FXHQ25_Autograph_Festival_Pro_Graphics_AUTOGRAPHS_WHITE_632_X_386.png',
    PHOTO_OP:
      '/uploads/FXHQ25_Photo_Op_Festival_Pro_Graphics_PO_WHITE_632_X_386.png',
  },
};

export const ribbonMap = {
  WHITE_RIBBON_BLACK_TEXT: '/images/guests/white-ribbon.png',
  BLACK_RIBBON_WHITE_TEXT: '/images/guests/black-ribbon.png',
};
